import {Injectable} from "@angular/core";
import {Withdrawal} from "../model/withdrawal";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {SessionActions} from "../../shared/actions/session.actions";
import {IAppState} from "../../shared/redux-store/store";
import {NgRedux} from "@angular-redux/store";
import {map} from "rxjs/operators";
import {FetchWithdrawlsQuery} from '../../shared/graphql/graphql.types';

export const storeManagementFragments = {
  withdrawal: gql`
    fragment WithdrawalFields on Withdrawal {
      cuid, label, withdrawal_timestamp,
      withdrawal_reason_type,
      withdrawal_note
      withdrawal_reason {
        cuid, label, __typename,
        ... on Mission {
          mission_number, mission_date
        }
      }
      consumer {
        cuid, label, __typename,
        ... on AdministrationUnit {
          name
        }
        ... on Vehicle {
          license_plate
        }
      }
      total_amount,
      withdrawn_stocks {
        cuid, label,
        stock {cuid, label, act_stock},
        amount,
        medicine_book_entry {
          cuid label sign_url
        }
      }

    }
  `
};

export const fetchWithdrawalsQuery = gql`
  query FetchWithdrawls($depot_id: String, $adminUnitCuid: String, $limit: Int, $offset: Int, $queryString: String) {
    fetchWithdrawals(depot_id: $depot_id, adminUnitCuid: $adminUnitCuid, limit: $limit, offset: $offset, queryString: $queryString) {
      items {...WithdrawalFields}
      total_items, total_pages
    }
  }

  ${storeManagementFragments.withdrawal}
`;

@Injectable()
export class WithdrawalService extends VisbosService {

  constructor(apollo?: Apollo, ngRedux?: NgRedux<IAppState>, sessionActions?: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getWithdrawals(depotCuid?: string | Observable<string>, adminUnitCuid?: string | Observable<string>,
                        limit?: number | Observable<number>, offset?: number | Observable<number>, queryString?: string | Observable<string>): ApolloQueryObservable<FetchWithdrawlsQuery> {
    return this.fetchItems({
      query: fetchWithdrawalsQuery,
      variables: {
        depot_id: depotCuid,
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$,
        limit: limit,
        offset: offset,
        queryString: queryString
      }
    });
  }

  public createWithdrawal(withdrawalData, medicineAuthData?): Observable<Withdrawal> {

    return this.mutate<Withdrawal>({
      mutation: gql`
        mutation CreateWithdrawal($withdrawal_input: WithdrawalInput!, $medicineAuthData: MedicineStockChangeInput) {
          createWithdrawal(withdrawal_input: $withdrawal_input, medicine_withdrawal_data: $medicineAuthData) {
            ...WithdrawalFields
          }
        }

        ${storeManagementFragments.withdrawal}
      `,
      variables: {
        withdrawal_input: this.processData(withdrawalData),
        medicineAuthData: medicineAuthData
      },
      refetchQueries: ['FetchWithdrawls'],
    }).pipe(map((res: any) => res.data.createWithdrawal)) as Observable<Withdrawal>;

  }

  public updateWithdrawal(cuid: string, withdrawalData): ApolloQueryObservable<Withdrawal> {
    return undefined;
  }

  public addStockToWithdrawal(stockCuid, withdrawal) {

  }

  public deleteWithdrawnItem(wd, wds) {

  }

  protected processData(data): any {
    let processedData = JSON.parse(JSON.stringify(data));

    delete processedData.consumer;
    delete processedData.withdrawal_reason;
    delete processedData.is_complete;
    delete processedData.authenticated_user;

    //TODO: Provide token

    for (let wdSt of processedData.withdrawn_stocks) {
      wdSt.stock_id = wdSt.stock && !wdSt.stock_id ? wdSt.stock.cuid : wdSt.stock_id;
      delete wdSt.stock;
    }

    //return pruneEmpty(processedData);
    return processedData;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/withdrawal.service.ts